import _ from 'lodash'

export const FETCHING_MYD_EVALUATIONS = 'FETCHING_MYD_EVALUATIONS'
export const FETCHED_MYD_EVALUATIONS = 'FETCHED_MYD_EVALUATIONS'
export const FETCHING_MYD_EVALUATION = 'FETCHING_MYD_EVALUATION'
export const FETCHED_MYD_EVALUATION = 'FETCHED_MYD_EVALUATION'
export const UPDATING_MYD_EVALUATION = 'UPDATING_MYD_EVALUATION'
export const UPDATED_MYD_EVALUATION = 'UPDATED_MYD_EVALUATION'


const mydEvaluationsInit = {
  isFetching: false,
  data: [],
  meta: {},
}

export function mydEvaluations(mydEvaluations=mydEvaluationsInit, action) {
  switch(action.type) {
    case FETCHING_MYD_EVALUATIONS:
      return {
        ...mydEvaluationsInit,
        isFetching: true,
      }

    case FETCHED_MYD_EVALUATIONS:
      return {
        isFetching: false,
        data: action.mydEvaluations,
        meta: action.meta,
      }

    case UPDATED_MYD_EVALUATION:
      return {
        ...mydEvaluations,
        isFetching: false,
        data: _.map(
          mydEvaluations.data,
          mydEvaluation => {
            if (action.mydEvaluation.id === mydEvaluation.id) {
              return action.mydEvaluation
            }
            return mydEvaluation
          }
        )
      }

    default:
      return mydEvaluations
  }
}


const mydEvaluationInit = {
  isFetching: false,
  data: {},
}

export function mydEvaluation(mydEvaluation=mydEvaluationInit, action) {
  switch(action.type) {
    case FETCHING_MYD_EVALUATION:
      return {
        isFetching: true,
        data: {},
      }

    case FETCHED_MYD_EVALUATION:
      return {
        isFetching: false,
        data: action.mydEvaluation,
      }

    default:
      return mydEvaluation
  }
}
